import gql from 'graphql-tag';

const GraphQL = {
  Query: {
    NOTIFICATIONS: gql`
      query Notifications($receiverkey: Int!) {
        notifications(receiverkey: $receiverkey) {
          noticekey
          subject
          body
          created
          receiverkey
          received
          read
          hidden
          templatekey
          assets {
            coursekey
            courseversion
            groupkey
            layer
            memberkey
            modulekey
            userkey
          }
        }
      }
    `,
    SENT_NOTIFICATIONS: gql`
      query SentNotifications($senderkey: Int!) {
        sentNotifications(senderkey: $senderkey) {
          noticekey
          senderkey
          subject
          body
          created
          emailed
        }
      }
    `,
    USER_OPTIONS: gql`
      query UserOptions($userkey: Int!) {
        userOptions(userkey: $userkey) {
          userkey
          version
          assets {
            locale
            notification
            emailOptions {
              admin
              expiry
              content
              permissions
              assessment
            }
            timezone
            version
          }
          created
          modified
        }
      }
    `
  },
  Mutation: {
    UPDATE_NOTIFICATION_STATE: gql`
      mutation UpdateNotificationState(
        $noticekey: Int!
        $receiverkey: Int!
        $markAsRead: Boolean!
        $hidden: Boolean!
      ) {
        updateNotificationState(
          noticekey: $noticekey
          receiverkey: $receiverkey
          markAsRead: $markAsRead
          hidden: $hidden
        ) {
          noticekey
          subject
          body
          created
          receiverkey
          received
          read
          hidden
        }
      }
    `,
    UPDATE_NOTIFICATION_SETTING: gql`
      mutation UpdateNotificationSetting(
        $userkey: Int!
        $userOptionAssets: UserOptionAssetsInput
      ) {
        updateNotificationSetting(
          userkey: $userkey
          userOptionAssets: $userOptionAssets
        ) {
          userkey
          version
          assets {
            locale
            notification
            emailOptions {
              admin
              expiry
              content
              permissions
              assessment
            }
            timezone
            version
          }
          created
          modified
        }
      }
    `,
    SEND_GROUP_NOTIFICATION: gql`
      mutation SendGroupNotification(
        $senderkey: Int!
        $groupkey: Int!
        $noticeAttributes: NoticeAttributesInput
      ) {
        sendGroupNotification(
          senderkey: $senderkey
          groupkey: $groupkey
          noticeAttributes: $noticeAttributes
        ) {
          receiver {
            noticekey
            receiverkey
            read
            hidden
            received
            emailed
          }
          groupReminder {
            groupkey
            noticekey
            sent
            scheduled
          }
        }
      }
    `,
    UPDATE_ALL_NOTIFICATIONS: gql`
      mutation UpdateAllNotifications($receiverkey: Int!, $action: String!) {
        updateAllNotifications(receiverkey: $receiverkey, action: $action)
      }
    `,
    SEND_USER_NOTIFICATION: gql`
      mutation sendUserNotification(
        $senderkey: Int!
        $receiverkeys: [Int]!
        $noticeAttributes: NoticeAttributesInput
      ) {
        sendUserNotification(
          senderkey: $senderkey
          receiverkeys: $receiverkeys
          noticeAttributes: $noticeAttributes
        ) {
          receiver {
            noticekey
            receiverkey
            read
            hidden
            received
            emailed
          }
          noticeReminder {
            reminderkey
            receiverkey
            sent
            scheduled
          }
        }
      }
    `
  }
};

export default GraphQL;
